export const ACTS = [
  {
    id: 'departure',
    from: 0,
    to: 0.12,
    kicker: 'CHARTED SPACE FALLING ASTERN',
    title: 'Last Light',
  },
  {
    id: 'signal',
    from: 0.12,
    to: 0.28,
    kicker: 'UNMAPPED EMISSION',
    title: 'The Distant Signal',
  },
  {
    id: 'approach',
    from: 0.28,
    to: 0.43,
    kicker: 'PROXIMITY EVENT',
    title: 'Crown Approach',
  },
  {
    id: 'eclipse',
    from: 0.43,
    to: 0.57,
    kicker: 'WAYPOINT OCCULTATION',
    title: 'Waypoint Eclipse',
  },
  {
    id: 'braids',
    from: 0.57,
    to: 0.70,
    kicker: 'STELLAR TIDELINE',
    title: 'Among the Braids',
  },
  {
    id: 'current',
    from: 0.70,
    to: 0.86,
    kicker: 'LIGHT-SAIL TRANSIT',
    title: 'The Pale Current',
  },
  {
    id: 'shore',
    from: 0.86,
    to: 1.01,
    kicker: 'UNCATALOGUED LIGHT',
    title: 'The Far Shore',
  },
];

export function clamp01(value) {
  return Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0));
}

export function actIndexAt(t) {
  const value = clamp01(t);
  const index = ACTS.findIndex((act) => value >= act.from && value < act.to);
  return index < 0 ? ACTS.length - 1 : index;
}

export function actAt(t) {
  return ACTS[actIndexAt(t)];
}
